<template>
  <div
    class="fr-ac-jc btn"
    @click="handleClick"
    :class="{
      'ui-border': isUiBorder,
      opa4: disabled,
      margin: margin,
      'ui-bg': isShowBg,
    }"
  >
    <IconFont class="mr-6" v-if="icon" :name="icon" :size="iconSize" />
    <div class="title">{{ title }}</div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BaseButton',
  props: {
    // type: {
    //     type: String as () => 'primary' | 'success' | 'warning' | 'danger' | 'info' | 'text',
    //     default: 'primary'
    // },
    // size: {
    //     type: String as () => 'large' | 'medium' | 'small' | 'mini',
    //     default: 'medium'
    // },
    title: {
      type: String,
      default: '', // 涉及多语言，此处不设置默认值，完全由外部传入
    },
    icon: {
      type: String,
      default: '',
    },
    iconSize: {
      type: [String, Number],
      default: 14,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    class: {
      type: String,
      default: '',
    },
    //是否彩色边框
    isUiBorder: {
      type: Boolean,
      default: false,
    },
    //右边距
    margin: {
      type: Boolean,
      default: false,
    },
    //是否显示背景色
    isShowBg: {
      type: Boolean,
      default: false,
    },
    // loading: {
    //     type: Boolean,
    //     default: false
    // },
  },
  emits: ['click'],
  setup(props, { emit }) {
    const handleClick = (event: MouseEvent) => {
      if (!props.disabled) {
        emit('click', event);
      }
    };

    return {
      handleClick,
    };
  },
});
</script>

<style scoped lang="scss">
.btn {
  height: 32px;
  padding: 0 14px;
  border-radius: var(--border-radius);
  border: 1px solid var(--border-color-primary);
  color: var(--text-color-primary);
  cursor: pointer;

  &:hover {
    background: var(--btn-bg-color-primary-2);
    /*background: linear-gradient(94deg, rgb(160, 101, 255, 0.4) 0%, rgb(75, 143, 249, 0.4) 62%, rgb(36, 214, 146, 0.4) 100%);*/
  }
}

.margin {
  margin-right: 16px;
}

.title {
  font-size: 14px;
  color: var(--text-color-primary);
}
</style>
